export var DeduplicationStage;
(function (DeduplicationStage) {
    DeduplicationStage["INITIALIZED"] = "INITIALIZED";
    DeduplicationStage["BLOCKING_IN_PROGRESS"] = "BLOCKING_IN_PROGRESS";
    DeduplicationStage["BLOCKING_COMPLETED"] = "BLOCKING_COMPLETED";
    DeduplicationStage["SIMILARITY_SCORING_IN_PROGRESS"] = "SIMILARITY_SCORING_IN_PROGRESS";
    DeduplicationStage["SIMILARITY_SCORING_COMPLETED"] = "SIMILARITY_SCORING_COMPLETED";
    DeduplicationStage["CLUSTERING_IN_PROGRESS"] = "CLUSTERING_IN_PROGRESS";
    DeduplicationStage["CLUSTERING_COMPLETED"] = "CLUSTERING_COMPLETED";
    DeduplicationStage["SAVING_IN_PROGRESS"] = "SAVING_IN_PROGRESS";
    DeduplicationStage["SAVING_COMPLETED"] = "SAVING_COMPLETED";
    DeduplicationStage["MERGING_IN_PROGRESS"] = "MERGING_IN_PROGRESS";
    DeduplicationStage["MERGING_COMPLETED"] = "MERGING_COMPLETED";
    DeduplicationStage["COMPLETED"] = "COMPLETED";
    DeduplicationStage["FAILED"] = "FAILED";
})(DeduplicationStage || (DeduplicationStage = {}));
export var DeduplicationTaskStatus;
(function (DeduplicationTaskStatus) {
    DeduplicationTaskStatus["SUCCESS"] = "SUCCESS";
    DeduplicationTaskStatus["ERROR"] = "ERROR";
    DeduplicationTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DeduplicationTaskStatus["PENDING"] = "PENDING";
})(DeduplicationTaskStatus || (DeduplicationTaskStatus = {}));
